import { config } from '../../../config';
import { restClient } from '../../shared/services/API/backend';
import { Game, GetGame, CreateParticipation } from '../models';

export const gameService = {
    get: async ({ id }: GetGame): Promise<Game> => {
        const response = await restClient.get<Game>(`${config.backend.rest.weddingUrl}/game/${id}`);
        return response.data;
    },
    addParticipation: async ({ gameId, ...rest }: CreateParticipation): Promise<void> => {
        await restClient.post(`${config.backend.rest.weddingUrl}/game/${gameId}/participation`, rest);
    },
};
